import { useContext } from "react"
import { Outlet } from "react-router-dom"
import StateContext from "../../context/stateContext"
import { Login } from "../login/login"

export const ProtectedRoutes = () => {
    const { token } = useContext(StateContext)
    return token ? <Outlet /> : <Login />
}
